/* "Every feature, explained" — PDP infographic explorer (snippets/pdp-infographic-explorer.liquid).
   Tabs: WAI-ARIA tabs pattern, automatic activation. Non-selected panels stay `hidden`, so their lazy
   thumbnails never download. Lightbox: native <dialog>; full-size (srcset) loads only on open, plus a
   prefetch of the next card. Esc is handled here because the store's Pandectes GDPR app calls
   preventDefault() on every Escape keydown, which kills native <dialog> cancel. */
(() => {
  const init = (root) => {
    if (root.dataset.igxReady) return;
    root.dataset.igxReady = '1';
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = tabs.map((t) => document.getElementById(t.getAttribute('aria-controls')));
    const lb = root.querySelector('[data-igx-lb]');
    const q = (s) => lb.querySelector(s);
    const img = q('[data-igx-img]');
    const name = root.dataset.igxName || '';

    // Flatten every card, in category order, for the lightbox walk.
    const seq = [];
    panels.forEach((p, gi) => p.querySelectorAll('[data-igx-open]').forEach((b, ci, all) => {
      seq.push({ b, gi, ci, gn: all.length });
      b.dataset.igxSeq = seq.length - 1;
    }));

    const select = (i, focus) => {
      tabs.forEach((t, j) => {
        const on = j === i;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
      tabs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      const rail = panels[i].querySelector('.igx-rail');
      if (rail) rail.scrollLeft = 0;
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => select(i)));
    root.querySelector('[role="tablist"]').addEventListener('keydown', (e) => {
      const cur = tabs.indexOf(document.activeElement);
      if (cur < 0) return;
      const to = { ArrowRight: cur + 1, ArrowLeft: cur - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (to === undefined) return;
      e.preventDefault();
      select((to + tabs.length) % tabs.length, true);
    });

    // Lightbox
    const groupsEl = q('[data-igx-groups]');
    groupsEl.innerHTML = '';
    tabs.forEach((t, gi) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'igx-lb-g';
      b.textContent = t.dataset.igxGroup;
      b.addEventListener('click', () => show(seq.findIndex((s) => s.gi === gi), true));
      groupsEl.appendChild(b);
    });
    let cur = 0;
    let opener = null;
    const saveData = !!(navigator.connection && navigator.connection.saveData);
    const prefetch = (s) => {
      if (saveData) return;
      const p = new Image();
      p.fetchPriority = 'low';
      p.sizes = img.sizes; p.srcset = s.b.dataset.srcset; p.src = s.b.dataset.full;
    };
    function show(i, announce) {
      cur = (i + seq.length) % seq.length;
      const s = seq[cur];
      const d = s.b.dataset;
      const grp = tabs[s.gi].dataset.igxGroup;
      img.srcset = d.srcset;
      img.src = d.full;
      // The caption below carries the card's title + tagline (and names the dialog's description), so the
      // image itself stays alt="" rather than reading the same words twice.
      q('[data-igx-grp]').textContent = grp;
      q('[data-igx-count]').textContent = `${s.ci + 1} of ${s.gn} · ${cur + 1} of ${seq.length} overall`;
      q('[data-igx-title]').textContent = d.title;
      q('[data-igx-sub]').textContent = d.sub || '';
      q('[data-igx-status]').textContent = announce
        ? `Card ${s.ci + 1} of ${s.gn} in ${grp}, ${cur + 1} of ${seq.length} overall: ${d.title}. ${d.sub || ''}`
        : '';
      [...groupsEl.children].forEach((b, j) => b.setAttribute('aria-current', j === s.gi ? 'true' : 'false'));
      if (seq.length > 1) prefetch(seq[(cur + 1) % seq.length]);
    }
    const open = (i, from) => {
      opener = from;
      show(i);
      lb.showModal();
      q('[data-igx-close]').focus();
    };
    const close = () => { if (lb.open) lb.close(); };
    lb.addEventListener('close', () => {
      // After the dialog is gone: leave the page on the category the shopper ended on, focus without scrolling.
      requestAnimationFrame(() => {
        const gi = seq[cur].gi;
        if (tabs[gi].getAttribute('aria-selected') !== 'true') select(gi);
        const back = opener && !opener.closest('[hidden]') ? opener : seq[cur].b;
        back.focus({ preventScroll: true });
      });
    });

    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-igx-open]');
      if (b) open(+b.dataset.igxSeq, b);
      else if (e.target.closest('[data-igx-all]')) open(0, e.target.closest('[data-igx-all]'));
    });
    q('[data-igx-close]').addEventListener('click', close);
    q('[data-igx-prev]').addEventListener('click', () => show(cur - 1, true));
    q('[data-igx-next]').addEventListener('click', () => show(cur + 1, true));
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight' && !e.target.closest('.igx-lb-groups')) show(cur + 1, true);
      else if (e.key === 'ArrowLeft' && !e.target.closest('.igx-lb-groups')) show(cur - 1, true);
    });
    const stage = q('[data-igx-stage]');
    let x0 = null;
    stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
    stage.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1), true);
    });
  };

  const boot = () => document.querySelectorAll('[data-igx]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
